import bgGradientSrc from './bg-gradient.svg';
import glassGradientDark from './bg-gradient-glass-dark.svg';
import glassGradientLight from './bg-gradient-glass-light.svg';
import importFileDark from './import-file-dark.webp';
import importFileLight from './import-file-light.webp';
import importWebsiteDark from './import-website-dark.webp';
import importWebsiteLight from './import-website-light.webp';
import siteImportDark from './site-import-dark.webp';
import siteImportLight from './site-import-light.webp';
import siteMultipleClientsDark from './site-multiple-clients-dark.raw.svg';
import siteMultipleClientsLight from './site-multiple-clients-light.raw.svg';

/**
 * Background image with a colourful gradient.
 */
export const bgGradient = {
    light: bgGradientSrc,
    dark: bgGradientSrc,
};

export const glassGradient = {
    light: glassGradientLight,
    dark: glassGradientDark,
};

export const siteMultipleClients = {
    light: siteMultipleClientsLight,
    dark: siteMultipleClientsDark,
};

export const siteImport = {
    light: siteImportLight,
    dark: siteImportDark,
};

export const importFile = {
    light: importFileLight,
    dark: importFileDark,
};

export const importWebsite = {
    light: importWebsiteLight,
    dark: importWebsiteDark,
};
